import { render, staticRenderFns } from "./woscomplaint.vue?vue&type=template&id=41042c74&scoped=true&"
import script from "./woscomplaint.vue?vue&type=script&lang=js&"
export * from "./woscomplaint.vue?vue&type=script&lang=js&"
import style0 from "./woscomplaint.vue?vue&type=style&index=0&id=41042c74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41042c74",
  null
  
)

component.options.__file = "woscomplaint.vue"
export default component.exports